<template>
  <BaseAction>
    <SecondaryButton @click.native="openDialog" textColor="#0965dc">
      <inline-svg :src="require('@/assets/svg/clock_blue.svg')" width="25" />
      Reschedule Interview
    </SecondaryButton>
    <RescheduleInterviewDialog
      v-if="isDialogOpen"
      :isOpen="isDialogOpen"
      @close="closeDialog"
    />
  </BaseAction>
</template>

<script>
import SecondaryButton from "@/components/common/Button/SecondaryButton";
import BaseAction from "@/components/common/BaseAction";
import RescheduleInterviewDialog from "@/views/interviews/dialogs/RescheduleInterviewDialog";
import InlineSvg from "vue-inline-svg";

export default {
  name: "RescheduleInterviewAction",
  components: {
    BaseAction,
    SecondaryButton,
    RescheduleInterviewDialog,
    InlineSvg
  },
  mounted() {
    if (this.shouldRescheduleInterview) {
      this.openDialog();
    }
  },
  data() {
    return {
      isDialogOpen: false
    };
  },
  computed: {
    shouldRescheduleInterview() {
      return Boolean(this.$route.query.shouldRescheduleInterview);
    }
  },
  methods: {
    openDialog() {
      this.isDialogOpen = true;
    },
    closeDialog() {
      this.isDialogOpen = false;
    }
  }
};
</script>
